if (!customElements.get('recipient-form')) {
  customElements.define(
    'recipient-form',
    class RecipientForm extends HTMLElement {
      connectedCallback() {
        const sectionId = this.dataset.sectionId;
        this.checkbox = this.querySelector(`#Recipient-checkbox-${sectionId}`);
        this.hiddenControl = this.querySelector(`#Recipient-control-${sectionId}`);
        this.offsetProperty = this.querySelector(`#Recipient-timezone-offset-${sectionId}`);
        this.fields = this.querySelector('[data-gift-recipient-fields]');
        this.inputs = [...this.fields.querySelectorAll('input, textarea')];
        this.liveRegion = this.querySelector(`#Recipient-fields-live-region-${sectionId}`);

        this.checkbox.disabled = false;
        this.hiddenControl.disabled = true;
        this.offsetProperty.value = new Date().getTimezoneOffset().toString();
        this.checkbox.addEventListener('change', this.onChange);
        this.fields.addEventListener('transitionend', this.onFieldsTransitionEnd);
        this.onChange();
      }

      disconnectedCallback() {
        this.checkbox?.removeEventListener('change', this.onChange);
        this.fields?.removeEventListener('transitionend', this.onFieldsTransitionEnd);
      }

      onChange = () => {
        const enabled = this.checkbox.checked;

        if (enabled) {
          this.fields.hidden = false;
          this.fields.style.maxHeight = '0px';
          this.fields.classList.remove('is-open');
          requestAnimationFrame(() => {
            this.fields.style.maxHeight = `${this.fields.scrollHeight}px`;
            this.fields.classList.add('is-open');
          });
        } else if (!this.fields.hidden) {
          this.fields.style.maxHeight = `${this.fields.scrollHeight}px`;
          requestAnimationFrame(() => {
            this.fields.style.maxHeight = '0px';
            this.fields.classList.remove('is-open');
          });
        }

        this.inputs.forEach((input) => {
          input.disabled = !enabled;
          if (!enabled) input.value = '';
        });
        this.offsetProperty.disabled = !enabled;
        this.liveRegion.textContent = enabled
          ? 'Gift recipient fields expanded'
          : 'Gift recipient fields collapsed';
      };

      onFieldsTransitionEnd = (event) => {
        if (event.propertyName === 'max-height' && !this.checkbox.checked) {
          this.fields.hidden = true;
        }
      };
    }
  );
}